import React from 'react';

import { Banner } from '@/components/ui/banners';
import { useTranslation } from '@/i18n';
import {
  DT_RESOLUTION_EXPIRY_WARNING_DAYS,
  formatToDdMmYyyy,
  getDtResolutionDaysUntilExpiry,
  getDtResolutionExpiryDate,
  isDtResolutionExpired,
} from '@/utils';


interface DtResolutionStatusBannersProps {
  dtAuthorizationDate: string | undefined;
}

/**
 * Avisos reactivos de vigencia de la resolución DT (ASIS-5054), calculados en el
 * cliente a partir del valor en vivo del campo — no depende de una respuesta del
 * backend. `NE_ShiftLegalRulesEvaluator` (ASIS-5040) aplica la misma regla como
 * defensa en profundidad al guardar (Create y Update).
 */
export const DtResolutionStatusBanners: React.FC<DtResolutionStatusBannersProps> = ({
  dtAuthorizationDate,
}) => {
  const { t: translate } = useTranslation('schedule');

  const expiryDate = getDtResolutionExpiryDate(dtAuthorizationDate);
  if (!expiryDate) return null;

  if (isDtResolutionExpired(dtAuthorizationDate)) {
    return (
      <div className="col-span-full">
        <Banner
          variant="error"
          text={translate('shift.create.validation.dtAuthorizationDateExpiredBanner', {
            date: formatToDdMmYyyy(expiryDate),
          })}
          data-testid="dt-resolution-expired-banner"
        />
      </div>
    );
  }

  const daysUntilExpiry = getDtResolutionDaysUntilExpiry(dtAuthorizationDate);
  if (daysUntilExpiry !== null && daysUntilExpiry <= DT_RESOLUTION_EXPIRY_WARNING_DAYS) {
    return (
      <div className="col-span-full">
        <Banner
          variant="warning"
          density="compact"
          text={translate('shift.create.fields.dtAuthorizationDateExpiringSoonWarning', {
            date: formatToDdMmYyyy(expiryDate),
          })}
          data-testid="dt-resolution-expiring-soon-banner"
        />
      </div>
    );
  }

  return null;
};

export default DtResolutionStatusBanners;
